<template>
    <div class="autocomplete-input">
        <p class="control has-icon has-icon-right">
          <input :disabled="disabled" ref="keyword" required v-model="keyword" class="form-control input-autocomplete" placeholder="" @input="_onInput($event.target.value)" @keyup.esc="isOpen = false" @blur="isOpen = false" @keydown.down="_moveDown" @keydown.up="_moveUp" @keydown.enter="_select">
          <i class="fa fa-angle-down"></i>
        </p>
        <ul v-show="isOpen" class="options-list">
          <li v-for="(option, index) in options" :key="index" :class="{
          'highlighted': index === highlightedPosition
          }" @mouseenter="highlightedPosition = index" @mousedown="_select">
            <slot name="item" :title="option.title" :description="option.description" :thumbnail="option.thumbnail"></slot>
          </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'AutocompleteInput',
    props: {
      options: {
        type: Array,
        required: true,
      },
      show: {type: Boolean, default: false},
      disabled: {type: Boolean, default: false},
    },
    data: () => ({
      isOpen: false,
      highlightedPosition: 0,
      keyword: '',
    }),
    watch: {
      show: function(){
        this.keyword = '';
        if(this.show){
          this.$refs.keyword.focus();
        }
      }
    },
    computed: {
      _filterOptions: function(){
        const re = new RegExp(this.keyword, 'i');
        return this.options.filter((o => o.title.match(re)) || (d => d.description.match(re)))
      }
    },
    created() {},
    mounted() {},

    methods: {
      _onInput: function(value){
        this.highlightedPosition = 0;
        this.isOpen = true;

        this.$emit('suggestions', value);
        if(value == ''){
          this.isOpen = false;
        }
      },
      _moveDown: function(){
        if(!this.isOpen){
          return
        }
        this.highlightedPosition = (this.highlightedPosition + 1) % this._filterOptions.length;
      },
      _moveUp: function(){
        if(!this.isOpen){
          return
        }
        this.highlightedPosition = this.highlightedPosition - 1 < 0 ? this._filterOptions.length - 1 : this.highlightedPosition - 1;
      },
      _select: function(){
        const selectedOption = this._filterOptions[this.highlightedPosition];
        this.$emit('select', selectedOption);
        this.isOpen = false;
        this.keyword = selectedOption.title;
        setTimeout(this._remove_value_from_input, 500); //si no se quiere que se vacie el input eliminar esta linea
      },
      _remove_value_from_input: function(){
        this.keyword = "";
      },
    }
}
</script>

<style lang="scss" scoped>

  input {
    border-radius: 3.5px;
    border: 1px solid var(--color-text-secondary);
    padding: 8px 10px;
    font-size: 16px;
    background-color: var(--color-surface);
    color: var(--color-text-secondary);
  }

  .control {
    margin: 0 0 3px;
  }
  .autocomplete-input {
    position: relative;
    z-index: 1;
  }

  ul.options-list li {
    width: 100%;
    flex-wrap: wrap;
    background: var(--color-surface);
    margin: 0;
    border-bottom: 1px solid var(--color-text-secondary);
    color: var(--color-text-secondary);
    padding: 7px;
    cursor: pointer;
  }

  ul.options-list li.highlighted {
    background: var(--color-active-surface);
  }

  ul.options-list li p {
    margin: 0;
    font-size: 11px;
  }

  ul.options-list li p strong {
    font-size: 13px;
  }

  .list-tickers .item {
    position: relative;
    float: left;
    background: #35add8;
    margin: 2px;
    font-size: 15px;
    padding: 4px;
    border-radius: 3px;
    color: white;
    cursor: pointer;
  }
</style>